import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import InfoPopup from '../info-popup';
import InfoPopupContent from './info-popup-content';
import messages from './messages';

const ProjectKeyLabelAndPopup = () => {
	const { formatMessage } = useIntl();

	return (
		<>
			{formatMessage(messages.projectKeyLabel)}
			<InfoPopup label={formatMessage(messages.infoTriggerLabel)} content={<InfoPopupContent />} />
		</>
	);
};

export default ProjectKeyLabelAndPopup;
